import { css } from "lit";

export const styles = css`
  :host {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    /* Mobile-friendly height constraints */
    min-height: 200px;
    height: 100%;

    &:has(.uploader-label) .media-uploader {
      min-height: calc(100% - 1rem);
    }

    &:not(.uploader-label) .media-uploader {
      min-height: 100%;
    }
  }

  .uploader-label {
    display: block;
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-large) / 1em var(--sds-typography-family-title),
      sans-serif;
    color: var(--sds-color-text-default-default);
    margin-bottom: var(--sds-size-space-400);
  }

  .media-uploader {
    position: relative;

    border-radius: var(--sds-size-radius-400);
    overflow: hidden;

    cursor: pointer;
    display: flex;
    justify-content: center;
  }

  .upload-container {
    z-index: 1;
    position: relative;
    display: flex;
    flex-grow: 1;
    width: 100%;
    aspect-ratio: 9 / 13;

    /* Mobile constraints to prevent overflow */
    max-width: 100%;
    max-height: 70vh;

    /* Ensure minimum height for iOS Safari when aspect-ratio doesn't compute
    */
    min-height: 200px;

    &.drag-over {
      .upload-placeholder {
        background: var(--sds-color-background-positive-hover);
      }

      .upload-overlay {
        opacity: 1;
      }
    }
    &.is-video {
      aspect-ratio: 8 / 9;
    }
  }

  .preview-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .media-preview-video,
  .media-preview-image {
    object-fit: cover;
    height: 100%;
    width: 100%;

    /* Prevent overflow beyond container */
    max-width: 100%;
    max-height: 100%;
  }

  :host([responsive]) .media-preview-video,
  :host([responsive]) .media-preview-image {
    object-fit: contain;
  }

  .media-preview-image.fit-auto-height {
    display: none;
  }
  .media-preview-video.fit-auto-height {
    height: auto;

    /* Maintain aspect ratio on auto-height videos */
    max-width: 100%;
  }

  .upload-placeholder,
  .current-file .upload-overlay {
    position: absolute;
    inset: 0 0 0 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: var(--media-uploader-placeholder-background, rgb(0 0 0 / 0.5));
    color: white;
    gap: var(--sds-size-space-200);
    display: flex;
    flex-grow: 1;
    transition: all 0.3s;
    z-index: 2;
  }

  .upload-placeholder.top-right {
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: space-between;
    padding: 20px;

    background: unset;

    ph-camera {
      display: block;
      filter: drop-shadow(0 0 2px black);
    }
  }
  .upload-placeholder.top-right:hover {
    background: rgb(0 0 0 / 0.5);
  }

  .current-file {
    display: flex;
    flex-grow: 1;
    justify-content: center;
  }

  .current-file .upload-overlay {
    opacity: 0;
  }

  .current-file:hover .upload-overlay {
    opacity: 1;
  }

  .uploading-state {
    position: absolute;
    padding: 20px;
    width: 100%;
    display: block;
  }

  .preview-controls {
    margin-top: var(--sds-size-space-200);
    display: flex;
    justify-content: center;
  }

  .error-message {
    z-index: 0;
    position: absolute;
    display: block;
    margin-top: var(--sds-size-space-100);
    color: var(--sds-color-text-negative);
    font-size: var(--sds-size-font-size-100);
  }

  .camera-icon,
  .upload-icon {
    color: white;
  }

  .upload-label {
    color: white;
    filter: drop-shadow(0 0 2px black);
    font-size: var(--sds-typography-scale-03);
    font-weight: var(--sds-typography-weight-regular);
    padding: 0 var(--sds-size-space-400);
  }

  .upload-subtitle {
    max-width: 360px;
    text-align: center;
    color: white;
    filter: drop-shadow(0 0 2px black);
    font-size: var(--sds-typography-scale-02);
    font-weight: var(--sds-typography-weight-regular);
    padding: 0 var(--sds-size-space-400);
  }
`;
